import React from 'react';
import { Empty, Space, Typography } from 'antd';
import FlareLogoMark from '../../session/FlareLogoMark.jsx';

const { Text, Title } = Typography;

export function EmptyTimeline({
  title = '开始新对话',
  description = '发送第一条消息后，这里会显示完整会话时间线。',
  imageUrl,
  imageAlt,
  logoLabel,
  logoTag,
  themeTokens,
}) {
  const normalizedImageUrl = String(imageUrl || '').trim();
  const showInstanceMark = !normalizedImageUrl && Boolean(logoLabel);
  return (
    <div style={{ display: 'grid', minHeight: '100%', placeItems: 'center' }}>
      <Space align="center" orientation="vertical" size={16} style={{ maxWidth: 960, width: '100%' }}>
        <Empty
          image={normalizedImageUrl ? (
            <img
              src={normalizedImageUrl}
              alt={String(imageAlt || 'logo')}
              style={{
                display: 'block',
                height: 34,
                margin: '0 auto',
                objectFit: 'contain',
                transform: 'translateX(1px)',
                width: 34,
              }}
            />
          ) : (
            <FlareLogoMark compact={!showInstanceMark} label={logoLabel} tag={logoTag} themeTokens={themeTokens} />
          )}
          styles={{ image: { height: 36 } }}
          description={(
            <Space orientation="vertical" size={4}>
              {!showInstanceMark && (
                <Title level={5} style={{ color: themeTokens.textPrimary, margin: 0 }}>{title}</Title>
              )}
              <Text style={{ color: themeTokens.textSecondary }} type="secondary">{description}</Text>
            </Space>
          )}
        />
      </Space>
    </div>
  );
}
